/**
 * Created by wczeng on 2021/6/3.
 */
import axios from 'axios'
import store from './store/store'
import router from './router/index'

// axios.defaults.baseURL = 'https://admin.altaitechnologies.com';
// axios.defaults.baseURL = 'https://kzfq1zh4ea.execute-api.ap-southeast-1.amazonaws.com/dev';
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.headers['x-api-key'] = 'SDNU87ko0r80ErPTJQYu27fdOpGIVxqC75E3cb5X'
axios.defaults.headers['Access-Control-Allow-Origin'] = '*'

axios.interceptors.request.use(
  config => {
    if (store.state.token) {
      var path = config.url.substring(config.url.lastIndexOf('/'))
      if (path === '/login') {
        config.headers['Authorization'] = 'Basic ' + store.state.token
        // config.headers["x-api-key"] = "SDNU87ko0r80ErPTJQYu27fdOpGIVxqC75E3cb5X"
      } else if (path === '/logout') {
        config.headers['Auth'] = store.state.token
        // config.headers["x-api-key"] = "SDNU87ko0r80ErPTJQYu27fdOpGIVxqC75E3cb5X"
      } else {
        config.headers['auth'] = store.state.token
        // console.log(config.headers['auth']);
      }
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
        case 403:
          store.commit('logout')
          router.currentRoute.path !== 'login' &&
          router.replace({path: 'login'})
          break
      }
    }
    return Promise.reject(error)
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/http.js